import "./menu.scss";

import anime from "animejs";

const menu = () => {
    //burger toggle menu
    const burgerMenu = document.getElementById('burger');
    if(!burgerMenu) return;

    const bodySite = document.querySelector('body');
    
    
    const menuContainer = document.querySelector('.menu-container');
    if(!menuContainer) return;    

    const menuContainerOverlay = document.querySelector('.menu-container__overlay');
    const closeMenuButton = document.getElementById('close-menu-button');

    const logoMenu = menuContainer.querySelector('.logo-site');

    const openMenu = () => {
        if(menuContainer.classList.contains('close')) {
            menuContainer.classList.remove('close');
            bodySite.classList.remove('open-menu');
        }
        menuContainer.classList.add('open');
        
        if(menuContainerOverlay.classList.contains('close')) {
            menuContainerOverlay.classList.remove('close');
            bodySite.classList.remove('open-menu');
        }
        menuContainerOverlay.classList.add('open');
        bodySite.classList.add('open-menu');
        

        //animation
        const menuPrimaryItems = menuContainer.querySelectorAll('#menu-primary .menu-item'); 
        if(!menuPrimaryItems.length) return;

        
        const menuSecondaryItems = menuContainer.querySelectorAll('#menu-secondary .menu-item'); 
        if(!menuSecondaryItems.length) return;
        
        const menuSocialItems = menuContainer.querySelectorAll('.wrap-social-links ul li'); 
        if(!menuSocialItems.length) return;

        const menuLangItems = menuContainer.querySelectorAll('.languages-list');
        if(!menuLangItems.length) return;

        anime.timeline({
            loop: false
        })
        .add({
            targets: logoMenu,
            opacity: [0,1],
            easing: "easeInOutQuad",
            duration: 300,
            delay: 500
        })
        .add({
            targets: menuPrimaryItems,
            opacity: [0,1],
            easing: "easeInOutQuad",
            duration: 500,
            delay: (el, i) => 80 * (i+1)
        }, '-=800')
        .add({
            targets: menuSecondaryItems,
            opacity: [0,1],
            easing: "easeInOutQuad",
            duration: 500,
            delay: (el, i) => 80 * (i+1)
        }, '-=500')
        .add({
            targets: menuSocialItems,
            opacity: [0,1],
            easing: "easeInOutQuad",
            duration: 300,
            delay: (el, i) => 80 * (i+1)
        }, '-=500')
        .add({
            targets: menuLangItems,
            opacity: [0,1],
            easing: "easeInOutQuad",
            duration: 300,
            delay: (el, i) => 80 * (i+1)
        }, '-=400')
    }
    
    const closeMenu = () => {
        menuContainer.classList.remove('open');
        menuContainer.classList.add('close');
        menuContainerOverlay.classList.remove('open');
        menuContainerOverlay.classList.remove('open');
        bodySite.classList.remove('open-menu');
    }

    burgerMenu.addEventListener('click', () => { 
        if(menuContainer.classList.contains('open')) {
            closeMenu();
        }
        else {
            openMenu();
        }
    })

    if(menuContainerOverlay) {
        menuContainerOverlay.addEventListener('click', () => {
            closeMenu();
        })
    }
    
    if(closeMenuButton) {
        closeMenuButton.addEventListener('click', () => {
            closeMenu();
        })
    }

    const closeAllOnKeyup = (e) => {
        if(e.keyCode === 27)
        {            
            closeMenu();
        }
    }

    document.addEventListener('keyup', closeAllOnKeyup);

    const linksWithSubMenu = document.querySelectorAll('.walker-menu > ul > li.dropdown');
    const anchorLinksSubMenu = document.querySelectorAll('.walker-menu > ul > li.dropdown > a');

    if(!linksWithSubMenu.length) return;

    // apertura del submenu
    const openSubMenu = (el) => {
        el.classList.add('open');
        let heightSubmenu = 0;
        let elementsInSubMenu = el.querySelectorAll(':scope > .dropdown-menu > li');        
        elementsInSubMenu.forEach(element => {
            heightSubmenu = heightSubmenu + element.offsetHeight;
        });

        el.querySelector(':scope > .dropdown-menu').style.height = heightSubmenu + 'px'
    }

    // chiusura del submenu
    const closeSubMenu = (el) => {
        el.classList.remove('open');
        el.querySelector(':scope > .dropdown-menu').style.height = '';
    }

    // chiusura di tutti i submenu
    const closeAllSubMenu = () => 
    {
        linksWithSubMenu.forEach(el => {
            closeSubMenu(el);
        });
    }
    
    const manageSubMenu = () => {
        const iconDropdown = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_dropdown"></use></svg></div>';
        linksWithSubMenu.forEach(el => {
            el.innerHTML = el.innerHTML + iconDropdown;
            let submenuIndicator = el.querySelector('.submenu-indicator');
            let navLink = el.querySelector('.dropdown-toggle');
            let submenuIndicatorPostion = navLink.offsetWidth + 30;
            if(submenuIndicator) {
                submenuIndicator.style.left = submenuIndicatorPostion + 'px';
            }
            el.addEventListener('click', () => {
                if(el.classList.contains('open')) {
                    closeSubMenu(el);
                }
                else {
                    closeAllSubMenu();
                    openSubMenu(el);
                }
            })
        });
    }

    manageSubMenu();
}

export default menu;